import React from "react";
import {
	Dialog,
	DialogSurface,
	DialogTitle,
	DialogBody,
	DialogContent,
	DialogActions,
	makeStyles,
} from "@fluentui/react-components";

const useStyles = makeStyles({
	surface: {
		marginLeft: "1rem",
		marginRight: "1rem",
	},
});

interface ModalProps {
	isOpen: boolean;
	onClose: () => void;
	title: string;
	actions: React.ReactNode;
	children: React.ReactNode;
}

export const Modal: React.FC<ModalProps> = ({
	isOpen,
	onClose,
	title,
	actions,
	children,
}) => {
	const styles = useStyles();

	return (
		<Dialog open={isOpen} onOpenChange={(_e, data) => !data.open && onClose()}>
			<DialogSurface className={styles.surface}>
				<DialogBody>
					<DialogTitle>{title}</DialogTitle>
					<DialogContent>{children}</DialogContent>
					<DialogActions>{actions}</DialogActions>
				</DialogBody>
			</DialogSurface>
		</Dialog>
	);
};

export default Modal;
